import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import InteractableObject, {
    createInteractableObjectListener,
    interactableObjectActionType,
} from '../../Inamove/Components/InteractableObject'
import Video from '../../Inamove/Components/Video/Video'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'

const levelId = 'level12'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    InventoryContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const level = await LevelController.loadLevel(levelId)

    // load stuff
    const findetTagebuchVideo = new Video(Config.CINEMATIC_PATH + 'V34-findetTagebuch' + Config.VIDEO_FILE_EXT)
    LoadingController.addToQueue(findetTagebuchVideo)

    // kisten Rätsel
    const successAudio = AudioController.add(Config.GAME_SCENE_PATH + 'K218/audio/success' + Config.AUDIO_FILE_EXT)

    const KisteMusterImage = new GameSceneImage('assets/kulissen/K218/Kiste-Muster.png')
    const KisteSchattenImage = new GameSceneImage('assets/kulissen/K218/Kiste-Schatten.png')
    const S_Image = new GameSceneImage('assets/kulissen/K218/Kiste-S.png')
    const I_Image = new GameSceneImage('assets/kulissen/K218/Kiste-I.png')
    const M_Image = new GameSceneImage('assets/kulissen/K218/Kiste-M.png')
    const O_Image = new GameSceneImage('assets/kulissen/K218/Kiste-O.png')
    const N_Image = new GameSceneImage('assets/kulissen/K218/Kiste-N.png')
    const E_Image = new GameSceneImage('assets/kulissen/K218/Kiste-E.png')

    ;[KisteMusterImage, KisteSchattenImage, S_Image, I_Image, M_Image, O_Image, N_Image, E_Image].forEach(
        LoadingController.addToQueue
    )

    const answer = 'simone'

    // This is the current index that is pressed
    // If 's' is pressed we will check, if the character at the position of pressedIndex in the answer is 's'.
    let pressedIndex = 0

    const fields = [
        {
            id: 's',
            image: S_Image,
        },
        {
            id: 'i',
            image: I_Image,
        },
        {
            id: 'm',
            image: M_Image,
        },
        {
            id: 'o',
            image: O_Image,
        },
        {
            id: 'n',
            image: N_Image,
        },
        {
            id: 'e',
            image: E_Image,
        },
    ]

    Object.values(fields).forEach((field) => {
        field.image.element.id = field.id + '-overlay'
        // remove info layer hotspots
        level.gameScenes.K218.infoLayer.hideHotspot(field.id)
        level.gameScenes.K218.addImage(field.image)
    })

    level.gameScenes.K218.addImage(KisteMusterImage)
    level.gameScenes.K218.addImage(KisteSchattenImage)

    function resetPressed() {
        fields.forEach((field) => {
            field.image.hide()
            pressedIndex = 0
        })
    }

    createInteractableObjectListener('boden', () => {
        resetPressed()
    })

    createInteractableObjectListener('kiste', () => {
        level.changeGameScene('K218')
    })

    await AudioController.addAllToLoadingQueue()
    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    LoadingContainer.hide()
    GameSceneContainer.show()

    LevelController.startLevel(levelId)

    return new Promise<void>((resolve) => {
        resetPressed()

        async function handleKisteClick(event: Event) {
            // @ts-ignore -- WHY: CustomEvent
            const interactableObject = event.detail.interactableObject as InteractableObject
            const { id } = interactableObject

            if (answer.includes(id)) {
                if (answer.indexOf(id) === pressedIndex) {
                    // clicked correctly
                    fields[pressedIndex].image.show()
                    // check if whole answer is found
                    if (pressedIndex === answer.length - 1) {
                        // challenge completed
                        await kisteFinished()
                    } else {
                        pressedIndex++
                    }
                }
            } else {
                resetPressed()
            }
        }

        async function kisteFinished() {
            removeEventListener(interactableObjectActionType, handleKisteClick)
            CinematicContainer.setVideo(findetTagebuchVideo)
            await AudioController.play(successAudio)
            CinematicContainer.show()
            GameSceneContainer.hide()
            level.stop()
            await CinematicContainer.play()
            resolve()
        }

        addEventListener(interactableObjectActionType, handleKisteClick)
    })
}
